import { render, staticRenderFns } from "./AgreementPage.vue?vue&type=template&id=fd6bdd76&"
import script from "./AgreementPage.vue?vue&type=script&lang=js&"
export * from "./AgreementPage.vue?vue&type=script&lang=js&"
import style0 from "./AgreementPage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports